module.exports = __webpack_public_path__ + "img/residue.01327d03.png";